import LXPTheme from './lxp'

export default {
  lxp: LXPTheme
}
